<template>
  <el-affix>
    <el-header>
      <el-menu class="el-menu-demo" mode="horizontal">
        <!-- <div class="header-index"> -->
        <!-- 网站图标 -->
        <img src="../img/icon.png" alt="" srcset="" class="el-header-logo" />

        <div class="flex-grow" />
        <!-- 菜单 -->
        <el-sub-menu index="1">
          <template #title>完整观看</template>
          <el-menu-item
            index="1-1"
            onclick="window.open ('https://www.bilibili.com/video/BV1WD1LBYEku/?share_source=copy_web&vd_source=cde34c7b8cbdabc72b04858cc61446dd')"
            >全程回放</el-menu-item
          >
          <el-menu-item
            index="1-2"
            onclick="window.open ('https://www.bilibili.com/video/BV14EsZzXEWi/?p=2&share_source=copy_web&vd_source=cde34c7b8cbdabc72b04858cc61446dd')"
            >片尾态度曲/花絮</el-menu-item
          >
        </el-sub-menu>

        <el-menu-item
          index="2"
          onclick="window.open ('https://cdn.gusui.site/public/ToS.html')"
          >用户条款</el-menu-item
        >
        <el-sub-menu index="3">
          <template #title>生态</template>
          <el-menu-item index="3-1" onclick="window.open ('https://www.gusui.site')"
            >谷穗社区工作室</el-menu-item
          >
          <!-- <el-menu-item index="3-2" onclick="window.open ('https://dsz.hello8693.xyz')"
            >电视猪</el-menu-item
          > -->
        </el-sub-menu>
      </el-menu>
    </el-header>
  </el-affix>
</template>
